.cq{background:var(--palette-white);}